// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"076fff26","239":"fc60e657","453":"5f3f8a42","455":"069f4e25"}[chunkId] + ".chunk.js";
};